import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";
import { Badge } from "../Badge";
import { formatDate, formatTime } from "./CaregiverDashboard";
import { MapPin } from "lucide-react";

export default function UpcomingVisits() {
  const [visits, setVisits] = useState(null);

  useEffect(() => {
    const today = new Date();
    const key = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
    api.get(`/caregiver/visits?date_from=${key}`).then((r) => setVisits(r.data.filter((v) => v.status !== "Cancelled"))).catch(() => setVisits([]));
  }, []);

  return (
    <div data-testid="caregiver-upcoming">
      <h1 className="font-display text-3xl md:text-4xl text-brand-navy">Upcoming Visits</h1>
      <p className="mt-2 text-[15px] text-slate-600">All future visits assigned to you.</p>

      {visits === null ? (
        <p className="mt-8 text-slate-500 font-semibold">Loading visits…</p>
      ) : (
        <ul className="mt-6 space-y-3">
          {visits.length === 0 && <li className="rounded-2xl border border-slate-200 bg-white p-8 text-center text-slate-500">No upcoming visits assigned to you right now.</li>}
          {visits.map((v) => (
            <li key={v.id}>
              <Link to={`/caregiver/visits/${v.id}`} data-testid={`upcoming-visit-${v.id}`} className="block rounded-2xl border border-slate-200 bg-white p-5 hover:border-brand-teal/40 hover:shadow-[0_12px_30px_rgb(11,27,61,0.08)] transition-shadow duration-300">
                <div className="flex flex-wrap items-start justify-between gap-3">
                  <div className="min-w-0">
                    <p className="font-display text-xl text-brand-navy">{v.patient_name}</p>
                    <p className="mt-1 text-sm font-semibold text-slate-600">{formatDate(v.date)}</p>
                    <p className="text-sm text-slate-500">{formatTime(v.start_time)} – {formatTime(v.end_time)} · {v.care_type}</p>
                    <p className="mt-1.5 flex items-start gap-1.5 text-sm text-slate-500"><MapPin className="h-4 w-4 mt-0.5 shrink-0 text-brand-teal" /> {v.patient_address || "Address on file"}</p>
                  </div>
                  <Badge kind="visit" value={v.status} />
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
